import React, { useContext } from 'react';
import type {
  Maybe,
  ProductMainOffer,
  Product,
  ProductProperties,
  Shipping,
} from 'src/types';

type Offers = {
  filteredOffers: ProductMainOffer[];
};

export interface ExtendedProductMainOffer extends ProductMainOffer {
  unfilteredShippings?: Array<Shipping>;
}

export const EmptyProduct = {
  id: 0,
  media: { count: 0 },
  name: '',
  classicFullPath: '',
  pathName: '',
  priceSummary: {},
  userReviewSummary: {},
  coreProperties: {},
} as Product & {
  coreProperties: ProductProperties;
};

interface IProductContextValue {
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
  offers: Offers;
  allOffers: ProductMainOffer[];
  allOffersWithActiveAdditives: ProductMainOffer[];
  priceInfoArticles?: Array<{
    pathName: string;
  }>;
}

const initialContextValue: IProductContextValue = {
  product: EmptyProduct,
  offers: { filteredOffers: [] },
  allOffers: [],
  allOffersWithActiveAdditives: [],
  priceInfoArticles: undefined,
};

export const ProductContext =
  React.createContext<IProductContextValue>(initialContextValue);

export const useProductContext = () => useContext(ProductContext);
